//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';

//-- Custom
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { TaxActions, alertActions, DiscountActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DatePicker from "react-datepicker";


//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
});

class Discounts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            deleteOpen: false,
            enableDisAdd: false,
            addingError: '',
            enableAdding: false,
            allDiscounts: false,
            perPage: 10,
            editingDiscountData: false,
            enableediting: false,
            enableDelete: false,
            deleteSent: false,
            discountExpiry: new Date(),
            editingdiscountExpiry: new Date(),
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        const { dispatch } = props;
        const { siteConstants } = props.language;
        //check if discount added
        //console.log("getDiscountSettings----------", props.getDiscountSettings);

        if (
            props.addDiscount !== undefined &&
            props.addDiscount.discountAdd !== undefined &&
            props.addDiscount.discountAdd.data !== undefined &&
            props.addDiscount.discountAdd.data.success === true
        ) {
            if (this.state.enableAdding === true) {
                this.setState({
                    enableDisAdd: false,
                    enableAdding: false,
                    addingError: '',
                    discountTitle: '',
                    discountDescription: '',
                    discountType: '',
                    discountValue: '',
                    discountStatus: '',
                });
                dispatch(alertActions.success(siteConstants.GEN_DISCOUNT_ADDED_NOTIFICATION));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;

                dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));

                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);
            }
        }


        // get all the tax settings from collection
        if (
            props.getDiscountSettings !== undefined &&
            props.getDiscountSettings.discGet !== undefined &&
            props.getDiscountSettings.discGet.data !== undefined &&
            props.getDiscountSettings.discGet.data.data !== undefined
        ) {
            const taxDataReceived = props.getDiscountSettings.discGet.data;

            this.setState({
                allDiscounts: taxDataReceived,
                totalPage: taxDataReceived.pagination.totalPages,
                totalDataCount: taxDataReceived.pagination.totalCount,
            })

        }

        // this props work after editing a tax setting
        if (
            props.editDiscounts !== undefined &&
            props.editDiscounts.discEdit !== undefined &&
            props.editDiscounts.discEdit.data !== undefined &&
            props.editDiscounts.discEdit.data.success === true
        ) {
            if (this.state.enableediting === true) {
                this.setState({ editingDiscountData: false, enableediting: false, addingError: '' });
                dispatch(alertActions.success(siteConstants.GEN_DISCOUNT_UPDATED_NOTIFICATION));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;

                dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));

                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);
            }
        }

        // when deleting a data
        if (
            props.deleteDiscount !== undefined &&
            props.deleteDiscount.discDelete !== undefined &&
            props.deleteDiscount.discDelete.data !== undefined &&
            props.deleteDiscount.discDelete.data.success === true
        ) {
            if (this.state.deleteSent === true) {
                this.setState({ enableDelete: false, deleteDiscountId: false, deleteSent: false })

                dispatch(alertActions.success(siteConstants.GEN_DISCOUNT_DELETE_NOTIFICATION));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;

                dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));

                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);

            }


        }



    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;
        this.setState({ perPage: e.target.value })

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));
    }

    /*
    * searchTaxList - User can search data from the database and it will appear
    */
    searchTaxList(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(DiscountActions.getDiscounts(apiConstants.SEARCH_DISCOUNT, postData));
        } else {
            dispatch(DiscountActions.getDiscounts(apiConstants.GET_DISCOUNT, postData));
        }
    }

    //close add tax popup
    closeAddTaxPop = () => {
        this.setState({
            enableDisAdd: false,
            addingError: ''
        })
    }

    //save the discount data
    handleSubmit = () => {
        const { dispatch } = this.props;
        const { siteConstants } = this.props.language;
        const { discountTitle, discountDescription, discountType, discountValue, discountStatus, discountExpiry } = this.state;

        if (discountTitle === undefined || discountTitle === '') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_TITLE + ' is required!!' }) }
        else if (discountDescription === undefined || discountDescription === '') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_DESCRIPTION + ' is required!!' }) }
        else if (discountType === undefined || discountType === '' || discountType === '---') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_TYPE + ' is required!!' }) }
        else if (discountValue === undefined || discountValue === '' || discountValue === '---') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_VALUE + ' is required!!' }) }
        else if (discountStatus === undefined || discountStatus === '') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_STATUS + ' is required!!' }) }
        else {
            this.setState({ enableAdding: true });
            const postData = {};
            postData.discountTitle = discountTitle;
            postData.discountDescription = discountDescription;
            postData.discountType = discountType;
            postData.discountValue = discountValue;
            postData.discountStatus = discountStatus;
            postData.expiryDate = this.state.discountExpiry;

            dispatch(DiscountActions.saveDiscount(apiConstants.SAVE_DISCOUNT, postData));
        }



    }

    // edit handle for discount data
    handleSubmitEdit = () => {
        const { dispatch } = this.props;
        const {
            editingDiscountId,
            editingdiscountTitle,
            editingdescription,
            editingdiscountType,
            editingdiscountValue,
            editingdiscountExpiry,
            editingdiscountStatus
        } = this.state;
        const { siteConstants } = this.props.language;
        if (editingdiscountTitle === undefined || editingdiscountTitle === '') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_TITLE + ' is required!!' }) }
        else if (editingdescription === undefined || editingdescription === '') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_DESCRIPTION + ' is required!!' }) }
        else if (editingdiscountType === undefined || editingdiscountType === '' || editingdiscountType === '---') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_TYPE + ' is required!!' }) }
        else if (editingdiscountValue === undefined || editingdiscountValue === '' || editingdiscountValue === '---') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_VALUE + ' is required!!' }) }
        else if (editingdiscountStatus === undefined || editingdiscountStatus === '' || editingdiscountStatus === '---') { this.setState({ addingError: siteConstants.LABEL_DISCOUNT_STATUS + ' is required!!' }) }
        else {
            this.setState({ enableediting: true });
            const postData = {};
            postData.id = editingDiscountId;
            postData.discountTitle = editingdiscountTitle;
            postData.discountDescription = editingdescription;
            postData.discountType = editingdiscountType;
            postData.discountValue = editingdiscountValue;
            postData.discountStatus = editingdiscountStatus;
            postData.expiryDate = editingdiscountExpiry;

            dispatch(DiscountActions.editDiscount(apiConstants.EDIT_DISCOUNT, postData));
        }
    }


    // popup for editing the discount data
    editDiscounts = (discountData) => {
        this.setState({
            editingDiscountData: true,
            editingDiscountId: discountData._id,
            editingdiscountTitle: discountData.discountTitle,
            editingdescription: discountData.description,
            editingdiscountType: discountData.discountType,
            editingdiscountValue: discountData.discountValue,
            editingdiscountExpiry: new Date(discountData.expiry),
            editingdiscountStatus: discountData.status
        });
    }

    //close the pop for edit
    closeEditTaxPop = () => {
        this.setState({ editingDiscountData: false, addingError: '' });
    }

    // popup close and handle functions
    openAddTaxSetting = () => { this.setState({ enableDisAdd: !this.state.enableDisAdd }); }
    handleClose = () => { this.setState({ enableDisAdd: !this.state.enableDisAdd, addingError: '' }) };
    onChangeHandleField = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleDateChange = (date) => {
        const selectedDate = new Date(date);
        const todayDate = new Date();
        if (selectedDate > todayDate) {
            this.setState({
                discountExpiry: date,
                editingdiscountExpiry: date,
            });
        } else {
            this.setState({
                discountExpiry: todayDate,
                editingdiscountExpiry: todayDate,
            });
        }


    }

    // delete tax record functions
    DeletePopupOpen = (discId) => { this.setState({ enableDelete: true, deleteDiscountId: discId }) }
    closeDeletePopup = () => { this.setState({ enableDelete: false, deleteDiscountId: false }) }
    deletingDiscountRecord = () => {
        const { dispatch } = this.props;
        if (this.state.deleteDiscountId) {
            this.setState({ deleteSent: true, })
            let postData = {};
            postData.discid = this.state.deleteDiscountId;

            dispatch(DiscountActions.deleteDiscount(apiConstants.DELETE_DISCOUNT, postData));
        }
    }
    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_DISCOUNTS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <div>
                                    <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_DISCOUNTS}</h1>
                                </div>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddTaxSetting()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchTaxList(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col">{siteConstants.LABEL_DISCOUNT_TITLE}</th>
                                                    <th scope="col">{siteConstants.LABEL_DISCOUNT_DESCRIPTION}</th>
                                                    <th width="col">{siteConstants.LABEL_DISCOUNT_TYPE}</th>
                                                    <th width="col">{siteConstants.LABEL_DISCOUNT_VALUE}</th>
                                                    <th width="col">{siteConstants.LABEL_DISCOUNT_STATUS}</th>
                                                    <th width="col">{siteConstants.LABEL_DISCOUNT_EXPIRY}</th>
                                                    <th width="col">{siteConstants.LABEL_DISCOUNT_CREATED_DATE}</th>
                                                    <th width="col">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.allDiscounts.data !== undefined &&
                                                        this.state.allDiscounts.data.length > 0 ?
                                                        this.state.allDiscounts.data.map((thisDiscount, index) => {
                                                            let stText = 'Active';
                                                            if (thisDiscount.status === 0) { stText = 'Deactive'; }
                                                            let crtdDate = new Date(thisDiscount.createdAt);
                                                            let exprdDate = new Date(thisDiscount.expiry);
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisDiscount.discountTitle}</td>
                                                                    <td>{thisDiscount.description}</td>
                                                                    <td>{thisDiscount.discountType}</td>
                                                                    <td>{thisDiscount.discountType == 'percentage' ? thisDiscount.discountValue + '%' : config.currencyCode + thisDiscount.discountValue}</td>
                                                                    <td>{stText}</td>
                                                                    <td>{exprdDate !== undefined ? exprdDate.toLocaleString("en-US", options) : ''}</td>
                                                                    <td>{crtdDate !== undefined ? crtdDate.toLocaleString("en-US", options) : ''}</td>
                                                                    <td className="tdTextCenter">
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editDiscounts(thisDiscount)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.DeletePopupOpen(thisDiscount._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="9" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add category popup */}
                    <Dialog
                        open={this.state.enableDisAdd}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                        fullWidth="true"
                    >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_ADD_DISCOUNT_POP_TITLE}</DialogTitle>
                        <DialogContent>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_TITLE} (*)</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_TITLE}
                                            className="form-control"
                                            name="discountTitle"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_DESCRIPTION} (*)</label>
                                        <textarea
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_DESCRIPTION}
                                            className="form-control"
                                            name="discountDescription"
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_TYPE} (*)</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="discountType"
                                        >
                                            <option>---</option>
                                            <option value="flat">Flat</option>
                                            <option value="percentage">Percentage</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_VALUE}</label>
                                        <input
                                            type="number"
                                            min="1"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_VALUE}
                                            className="form-control"
                                            name="discountValue"
                                        />
                                    </div>
                                </div>



                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_STATUS}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="discountStatus"
                                        >
                                            <option value="1">---</option>
                                            <option value="1">Active</option>
                                            <option value="0">Deactive</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_EXPIRY}</label><br />
                                        <DatePicker
                                            selected={this.state.discountExpiry}
                                            onChange={(e) => this.handleDateChange(e)}
                                            className="form-control"
                                            popperPlacement='top-start'
                                            name="discountExpiry"
                                        />

                                    </div>
                                </div>



                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <p style={{ color: 'red' }}>{this.state.addingError}</p>
                                    </div>
                                </div>

                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddTaxPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.editingDiscountData}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                        fullWidth="true"
                    >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_POPUP_TAX_UPDATE}</DialogTitle>
                        <DialogContent>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_TITLE} (*)</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_TITLE}
                                            className="form-control"
                                            name="editingdiscountTitle"
                                            value={this.state.editingdiscountTitle}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_DESCRIPTION} (*)</label>
                                        <textarea
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_DESCRIPTION}
                                            className="form-control"
                                            name="editingdescription"
                                            value={this.state.editingdescription}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_TYPE} (*)</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="editingdiscountType"
                                            defaultValue={this.state.editingdiscountType}
                                        >
                                            <option>---</option>
                                            <option value="flat">Flat</option>
                                            <option value="percentage">Percentage</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_VALUE}</label>
                                        <input
                                            type="number"
                                            min="1"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_DISCOUNT_VALUE}
                                            className="form-control"
                                            name="editingdiscountValue"
                                            value={this.state.editingdiscountValue}
                                        />
                                    </div>
                                </div>



                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_STATUS}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="editingdiscountStatus"
                                            defaultValue={this.state.editingdiscountStatus}
                                        >
                                            <option>---</option>
                                            <option value="1">Active</option>
                                            <option value="0">Deactive</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_DISCOUNT_EXPIRY}</label><br />
                                        <DatePicker
                                            selected={this.state.editingdiscountExpiry}
                                            onChange={(e) => this.handleDateChange(e)}
                                            className="form-control"
                                            popperPlacement='top-start'
                                            name="editingdiscountExpiry"
                                        />

                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <p style={{ color: 'red' }}>{this.state.addingError}</p>
                                    </div>
                                </div>

                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" onClick={() => this.closeEditTaxPop()}>{siteConstants.LABEL_CANCEL}</Button>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEdit(e)}>{siteConstants.LABEL_SAVE}</Button>
                        </DialogActions>
                    </Dialog>

                    {/* notify about delete */}
                    <Dialog open={this.state.enableDelete} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_SURE_DELETE_DISCOUNT_RECORD}</DialogTitle>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingDiscountRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addDiscount, addTaxSettings, getDiscountSettings, editDiscounts, deleteDiscount, getTaxSettings, editTaxSettings, deleteTaxSettings } = state;
    return {
        language,
        addDiscount,
        getDiscountSettings,
        editDiscounts,
        deleteDiscount,

        addTaxSettings,
        getTaxSettings,
        editTaxSettings,
        deleteTaxSettings
    };
}


export default connect(mapStateToProps)(withStyles(styles)(Discounts))
